import {
  FormControl,
  FormLabel,
  Select,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';

interface OptionItem {
  _id: string;
  title: string;
  [key: string]: any;
}

interface Props {
  name: string;
  value: string; // _id of selected option
  handleChange: (args: { name: string; id: string; title: string }) => void;
  disabled?: boolean;
  title: string;
  isRequiredFalse?: boolean;
  data: OptionItem[];
  isFromApi?: boolean;
}

const CustomSelect: React.FC<Props> = ({
  disabled,
  handleChange,
  name,
  value,
  title,
  isRequiredFalse,
  data,
  isFromApi
}) => {
  const textColor = useColorModeValue('navy.700', 'white');

  return (
    <FormControl isRequired={!isRequiredFalse}>
      <FormLabel
        display="flex"
        ms="4px"
        fontSize="sm"
        fontWeight="500"
        color={textColor}
        mb="8px"
      >
        {title}
      </FormLabel>
      <Select
        fontSize="sm"
        variant="main"
        h="44px"
        maxH="44px"
        me="20px"
        mb="24px"
        disabled={disabled}
        name={name}
        value={value || ''}
        onChange={(e) => {
          const selectedId = e.target.value;
          const selectedObj = data.find((item) => item._id === selectedId);
          if (selectedObj) {
            handleChange({
              name,
              id: selectedObj._id,
              title: selectedObj.title,
            });
          }
        }}
        color={textColor}
      >
        <option value="">Select</option>
        {data?.map((ele) => (
          <option key={ele._id} value={ele._id}>
            {isFromApi ? ele.title : ele.value}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
